import { Config } from "@config/config";

import { useModal } from "@components/ModalContext";
import { Col, Row } from "react-bootstrap";
import { Button } from "rsuite";
import { FiEye } from "react-icons/fi";
import Details from "./Details";
import { MdEmail } from "react-icons/md";
import { FaDownload } from "react-icons/fa";
import { apiSend, getRoute, pdfData } from "@services/axios";

import { success } from "@global/actions";
const Listing = ({ t, mode, data }) => {
  const { openModal, setFullscreen, setTitle } = useModal();
  const invoiceDetail = async (item) => {
    setFullscreen(true);
    setTitle("N° : " + item.invoice_number);
    openModal(<Details item={item} />);
  };

  const sendInvoice = async (item) => {
    window.wait(1);
    const response = await apiSend(
      [getRoute("INVOICE_RETRIEVE"), item.id, "send"].join("/"),
      "get"
    );

    window.wait(0);
    success(response?.data?.result?.message);
  };
  const pdfInvoice = async (item) => {
    window.wait(1);
    try {
      await pdfData(
        [getRoute("INVOICE_RETRIEVE"), item.id, "pdf"].join("/"),
        item.invoice_number
      );
    } catch (error) {
      console.log(error);
    }
    window.wait(0);
    success("fin fde téléchargement");
  };

  return (
    <>
      {data.map((item, index) => (
        <div
          key={index}
          className={`my-1 p-3 rounded ${
            mode === "dark" ? "bg-dark text-white" : "border bg-white text-dark"
          }`}
        >
          <Row className="align-items-center">
            <Col md="2">
              <div className="fs-6 fw-light">{item.invoice_number}</div>
            </Col>
            <Col md="2">
              <div className="fs-6 fw-light">{item.invoice_at}</div>
            </Col>
            <Col md="2">
              <div className="fs-6 fw-light">
                {item.currency} {item.amount}
              </div>
            </Col>

            <Col md="2">
              <div className={`fs-6 fw-light ${item.status}`}>
                {t(item.status)}
              </div>
            </Col>
            <Col md="2">
              <div className="fs-6 fw-light">{item.paid_at}</div>
            </Col>

            <Col md="2" className="text-right">
              <Button
                className="btn-blue btn-outline-blue  me-1 rounded"
                onClick={() => invoiceDetail(item)}
              >
                <FiEye />
              </Button>
              <Button
                className="btn-blue btn-outline-blue   me-1 rounded"
                onClick={() => sendInvoice(item)}
              >
                <MdEmail />
              </Button>

              <Button
                className="btn-blue btn-outline-blue   me-1 rounded"
                onClick={() => pdfInvoice(item)}
              >
                <FaDownload />
              </Button>
            </Col>
          </Row>
        </div>
      ))}
    </>
  );
};
export default Listing;
